import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
const Admin = () => import('./admin/Admin.vue')
const channel = () => import(/* webpackPrefetch: true */ './channel.vue')
const channelEmbed = () =>
  import(/* webpackPrefetch: true */ './channelEmbed.vue')
const frontpage = () => import(/* webpackPrefetch: true */ './frontpage.vue')

// const frontpageNew = () => import('./frontpageNew.vue')
const PageNotFound = () => import('./pageNotFound.vue')
const archive = () => import('./archive.vue')
// import selectChannel from '../helper/selectChannel.vue'
const channelAdmin = () => import('./admin/channelAdmin.vue')
const groupsAdmin = () => import('./admin/groupsAdmin.vue')
const videoAdmin = () => import('./admin/VideoAdmin.vue')

const frontpageAdmin = () => import('./admin/frontpageAdmin.vue')

Vue.use(Router)

const routes = [

  {
    path: '/42',
    name: '42',
    component: frontpage,
    meta: {
      title: '42',
      channel: true,
      channelName: '42',
      about: '42',
      db: '42'
    }
  },
  {
    path: '/embed/:channel?',
    component: channelEmbed
  },
  {
    path: '/2038',
    name: '2038',
    component: frontpage,
    meta: {
      title: '2038',
      channel: true,
      channelName: '2038',
      about: '2038',
      db: '2038'
    }
  },
  {
    path: '/realty-v',
    name: 'realty-v',
    component: frontpage,
    meta: {
      title: 'realty-v',
      channel: true,
      channelName: 'realty-v',
      db: 'realty-v',
      about: 'realty-v'
    }
  },
  {
    path: '/station-plus',
    name: 'station-plus',
    component: frontpage,
    meta: {
      title: 'station.plus',
      channel: true,
      channelName: 'station-plus',
      db: 'station-plus',
      about: 'station-plus'
    }
  },
  {
    path: '/',
    name: 'frontpage',
    component: frontpage,
    meta: {}
  },
  // {
  //   path: '/new',
  //   name: 'frontpageNew',
  //   component: frontpageNew,
  //   meta: {}
  // },
  {
    path: '/channel/42',
    name: 'channel_42',
    component: channel,
    meta: {
      title: '42',
      channel: true,
      about: '42',
      channelName: '42'
    }
  },
  {
    path: '/channel/2038',
    name: 'channel_2038',
    component: channel,
    meta: {
      title: '2038',
      channel: true,
      about: '2038',
      channelName: '2038'
    }
  },
  {
    path: '/channel/station-plus',
    name: 'channel_station-plus',
    component: channel,
    meta: {
      title: 'station.plus',
      channel: true,
      channelName: 'station-plus',
      about: 'station-plus'
    }
  },
  {
    path: '/channel/realty-v',
    name: 'channel_realty-v',
    component: channel,
    meta: {
      title: 'realty-v',
      channel: true,
      channelName: 'realty-v',
      about: 'realty-v'
    }
  },
  {
    path: '/archive/:channelName/:video?',
    name: 'archive',
    component: archive,
    meta: {
      title: 'Archive',
      channel: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: 'Admin',
      channel: false
    },
    children: [{
      path: '/admin/channel/:channel?',
      name: 'channelAdmin',
      component: channelAdmin,
      meta: {
        title: 'Channel Admin',
        channel: false
      }
    },
    {
      path: '/admin/video',
      name: 'videoAdmin',
      component: videoAdmin,
      props: {
        database: 'videos'
      },
      meta: {
        title: 'Video Admin',
        channel: false,
        db: 'videos'
      }
    },
    {
      path: '/admin/filler',
      name: 'fillerAdmin',
      component: videoAdmin,
      props: {
        database: 'filler'
      },
      meta: {
        title: 'Filler Admin',
        channel: false,
        db: 'filler'
      }
    },
    {
      path: '/admin/groups',
      name: 'groupsAdmin',
      component: groupsAdmin,
      props: {
        database: 'groups'
      },
      meta: {
        title: 'Groups Admin',
        channel: false,
        db: 'groups'
      }
    },
    {
      path: '/admin/frontpage',
      name: 'frontpageAdmin',
      component: frontpageAdmin,
      meta: {
        title: 'Frontpage Admin'
      }
    }

    ]
  },
  {
    path: '*',
    component: PageNotFound,
    meta: {
      title: 'Page not Found'
    }

  }
]

const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior() { // eslint-disable-line
    return {
      x: 0,
      y: 0
    }
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-112745740-1',
  router
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
